
export default {
    namespaced: true,
    state: {
        rawPositionsData: [],
        positionsData: [],
        currentPage: 1,
        totalRows: null,
        perPage: 60,
        siteList: [],
        regionList: [],
        currentRegionData: {},
        currentRegionId: null,
        currentSiteId: 1,
        currentSearchEngine: 'yandex',
        searchValue: '',
        sortField: 'brand.name',
        sortDir: 'asc',
        historyData: {},
        currentGroupId: null,
        groups: [],
        haveEmptyResponse: false,
        fieldHeader: [],
    },
    getters: {
        FIELD_HEADER: state => {
            return state.fieldHeader;
        },
        RAW_POSITIONS_DATA: state => {
            return state.rawPositionsData;
        },
        GROUPS: state => {
            return state.groups;
        },
        CURRENT_GROUP_ID: state => {
            return state.currentGroupId;
        },
        HISTORY_DATA: state => {
            return state.historyData;
        },
        SORT_FIELD: state => {
            return state.sortField;
        },
        SORT_DIR: state => {
            return state.sortDir;
        },
        SEARCH_VALUE: state => {
            return state.searchValue;
        },
        CURRENT_REGION_ID: state => {
            return state.currentRegionId;
        },
        CURRENT_SITE_ID: state => {
            return state.currentSiteId;
        },
        CURRENT_SEARCH_ENGINE: state => {
            return state.currentSearchEngine;
        },
        SITE_LIST: state => {
            return state.siteList;
        },
        REGION_LIST: state => {
            return state.regionList;
        },
        CURRENT_REGION_DATA: state => {
            return state.currentRegionData;
        },
        POSITIONS_DATA: state => {
            return state.positionsData;
        },
        CURRENT_PAGE: state => {
            return state.currentPage;
        },
        TOTAL_ROWS: state => {
            return state.totalRows;
        },
        PER_PAGE: state => {
            return state.perPage;
        },
        AMOUNT_PAGE: (state) => {
            return Math.ceil(state.totalRows/state.perPage);
        },
        HAVE_EMPTY_RESPONSE: state => {
            return state.haveEmptyResponse;
        },
    },
    mutations: {
        FIELD_HEADER: (state, payload) => {
            return state.fieldHeader = payload;
        },
        RAW_POSITIONS_DATA: (state, payload) => {
            return state.rawPositionsData = payload;
        },
        HAVE_EMPTY_RESPONSE: (state, payload) => {
            return state.haveEmptyResponse = payload;
        },
        GROUPS: (state, payload) => {
            return state.groups = payload;
        },
        CURRENT_GROUP_ID: (state, payload) => {
            return state.currentGroupId = payload;
        },
        HISTORY_DATA: (state, payload) => {
            return state.historyData = payload;
        },
        SEARCH_VALUE: (state, payload) => {
            return state.searchValue = payload;
        },
        SORT_FIELD: (state, payload) => {
            return state.sortField = payload;
        },
        SORT_DIR: (state, payload) => {
            return state.sortDir = payload;
        },
        CURRENT_REGION_ID: (state, payload) => {
            return state.currentRegionId = payload;
        },
        CURRENT_SITE_ID: (state, payload) => {
            return state.currentSiteId = payload;
        },
        CURRENT_SEARCH_ENGINE: (state, payload) => {
            return state.currentSearchEngine = payload;
        },
        SITE_LIST: (state, payload) => {
            return state.siteList = payload;
        },
        REGION_LIST: (state, payload) => {
            return state.regionList = payload;
        },
        CURRENT_REGION_DATA: (state, payload) => {
            return state.currentRegionData = payload;
        },
        POSITIONS_DATA: (state, payload) => {
            return state.positionsData = payload;
        },
        CURRENT_PAGE: (state, payload) => {
            return state.currentPage = payload;
        },
        TOTAL_ROWS: (state, payload) => {
            return state.totalRows = payload;
        },
        PER_PAGE: (state, payload) => {
            return state.perPage = payload;
        },
    },
    actions: {
        GET_GROUPS: async ({commit}, payload) => {
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/site-groups',
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    commit('GROUPS', responseData.data);
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },
        GET_REGIONS: async ({state, commit, dispatch}, payload) => {
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/site-regions/'+ state.currentGroupId +'/'+ state.currentSearchEngine,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    let data = responseData.data
                    let firstId = (data == null || data.length == 0) ? null : data[0].id
                    // set region list
                    state.regionList = [];
                    for (let key in data) {
                        let val = data[key]
                        let lang = state.currentSearchEngine == 'google' ? '-'+ val.lang : ''
                        state.regionList.push({
                            value: val.id, text: val.name +' ('+ val.regionCode + lang +')'
                        })
                    }
                    commit('CURRENT_REGION_ID', firstId);
                    payload.th.currentRegionId = firstId
                    // get data
                    dispatch('GET_DATA', {th: payload.th})
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },
        GET_DATA: async ({state, commit}, payload) => {
            if (state.currentRegionId == null) {
                return false
            }
            payload.th.showOverlay ++;
            payload.th.showBottomOverlay ++;
            let params = {
                perPage:                state.perPage,
                currentPage:            state.currentPage,
                currentSearchEngine:    state.currentSearchEngine,
                currentRegionId:        state.currentRegionId,
                searchValue:            state.searchValue,
                sortField:              state.sortField,
                sortDir:                state.sortDir,
            }
            let createParamsUrl = function (params) {
                let urlParams = [];
                for (let prop in params) {
                    if (params[prop] !== false && params[prop] !== '' && params[prop] !== "[]" && params[prop] !== null) {
                        urlParams.push(prop + '=' + encodeURIComponent(params[prop]));
                    }
                }
                return '?' + urlParams.join('&');
            }
            console.log(params)
            let urlParams = createParamsUrl(params);
            console.log(urlParams)

            await payload.th.$store.dispatch('SEND_GET', {
                url: '/group-positions/'+ state.currentGroupId + urlParams,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    let data = responseData.data;
                    if (data.positions == null) {
                        data.positions = []
                    }
                    state.totalRows = data.count;
                    state.currentRegionData = data.currentRegionData;
                    commit('FIELD_HEADER', data.fieldHeader == null ? [] : data.fieldHeader)
                    // set site list
                    state.siteList = data.sites;
                    // sort ang group by by site
                    state.rawPositionsData = state.rawPositionsData.concat(data.positions)
                    state.positionsData = payload.th.groupPositionData(state.rawPositionsData);
                    // prepare field of table
                    payload.th.prepareTableField()
                    // for the first time
                    if (state.currentPage === 1) {
                        // next load by 10 item
                        state.perPage = 30
                        state.currentPage = 2
                    }
                    // fix if is response empty
                    if (data.positions != null && data.positions.length > 0) {
                        state.currentPage ++
                    } else {
                        commit('HAVE_EMPTY_RESPONSE', true);
                    }
                    // scroll to same top
                    payload.th.scrollTo()

                },
                getResponse: () => {
                    payload.th.showOverlay = 0;
                    payload.th.showBottomOverlay --;
                },
            });
        },
        GET_HISTORY: async ({state}, payload) => {
            payload.th.showOverlay ++;
            state.historyData = {};
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/site-positions-history/'+ state.currentSearchEngine +'/'+ payload.id +
                    '?from='+ payload.from +'&to='+ payload.to,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    let data = responseData.data
                    state.historyData = {
                        labels: [],
                        datasets: [
                            {
                                label: 'частота',
                                data: [],
                                backgroundColor: '#e5e5e5',
                                borderWidth: 1
                            },
                            {
                                label: 'позиция',
                                data: [],
                                backgroundColor: '#555555',
                                borderWidth: 1
                            }
                        ]
                    }
                    for (let key in data) {
                        state.historyData.labels.push(data[key].year +'-'+ data[key].month +'-'+ data[key].day);
                        let frequency = data[key].frequency == 'null' ? 0 : data[key].frequency
                        let position = data[key].position == 'null' ? 0 : data[key].position
                        state.historyData.datasets[0].data.push(frequency);
                        state.historyData.datasets[1].data.push(position);
                    }
                },
                getResponse: () => {
                    payload.th.showOverlay --
                },
            });
        }
    }
}